<template>
  <div class="login-page">
    <div class="main-container">
      <!-- LOGIN SECTION -->
      <div class="login-section">
        <div class="login-inner">
          <!-- Language Switcher -->
          <div class="lang-switcher">
            <language-switcher />
          </div>
          <!-- Logo -->
          <img
            src="@/assets/logo/logo.png"
            class="login-logo"
            alt="Logo"
          >

          <!-- Text -->
          <div class="welcome-text">
            {{ $t("login.welcome") }}
          </div>
          <div class="app-title">
            Fit Daily Monitoring
          </div>

          <!-- Illustration -->
          <div class="illustration-box">
            <img
              src="@/assets/image/department.png"
              class="illustration-img"
              alt="Illustration"
            >
          </div>
          <button
            class="azure-btn"
            @click="loginAzure"
          >
            <img
              :src="icAzure"
              class="azure-icon"
              alt="azure"
            >
            {{ $t("login.button.login-azure") }}
          </button>
          <!-- Register -->
          <router-link
            class="register-btn"
            :to="{ name: 'registration' }"
          >
            {{ $t("login.button.login-guest") }}
          </router-link>

          <!-- Classic Login -->
          <div class="classic-login">
            <span />
            <div
              class="classic-link"
              @click="showClassicLogin = true"
            >
              {{ $t("login.button.login-classic") }}
            </div>
            <span />
          </div>
        </div>
      </div>

      <!-- DECORATION SECTION -->
      <div class="decoration-section">
        <img
          src="@/assets/image/bg.png"
          class="decoration-img"
          alt="Decoration"
        >
      </div>
    </div>
    <ClassicLoginModal
      v-if="showClassicLogin"
      @close="showClassicLogin = false"
      @require-mfa="openOtpModal"
    />
    <OtpVerificationModal
      v-if="showOtpModal"
      @close="showOtpModal = false"
      @success="showOtpModal = false"
    />
  </div>
</template>

<script>
import { loginRequest } from '../auth/MsalConfig'
import icAzure from '../assets/logo/ic_azure.png'
import LanguageSwitcher from '@/components/LanguangeSwitcher'
import ClassicLoginModal from '@/components/ClassicLoginModal'
import OtpVerificationModal from '@/components/OtpVerificationModal'

export default {
  components: {
    LanguageSwitcher,
    ClassicLoginModal,
    OtpVerificationModal
  },
  data () {
    return {
      icAzure,
      showClassicLogin: false,
      showOtpModal: false
    }
  },
  methods: {
    loginAzure () {
      this.$msal.loginRedirect(loginRequest)
    },
    openOtpModal () {
      this.showClassicLogin = false
      this.showOtpModal = true
    }
  }
}
</script>

<style scoped>
.login-page {
  height: 100vh;
  overflow: hidden;
  background: #4c2e88;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-container {
  width: 100%;
  max-width: 1600px;
  display: flex;
  gap: 32px;
  padding: 24px;
}

/* DECORATION */
.decoration-section {
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.decoration-img {
  width: 100%;
  max-width: 700px;
}

/* LOGIN */
.login-section {
  flex: 1;
  background: white;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  height: 100%;
}

.login-inner {
  width: 100%;
  height: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-logo {
  width: 64px;
  margin-bottom: 16px;
}

.welcome-text {
  font-size: 16px;
  font-weight: 600;
  color: #9aa0a6;
}

.app-title {
  font-size: 28px;
  font-weight: bold;
}

.illustration-box {
  margin-top: 24px;
  text-align: center;
}

.illustration-img {
  width: 55%;
  max-height: 180px;
  object-fit: contain;
}

.azure-btn {
  margin-top: 24px;
  width: 100%;
  background: #18a2b8;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.azure-icon {
  width: 20px;
  margin-right: 8px;
}

.register-btn {
  margin-top: 16px;
  padding: 14px;
  text-align: center;
  border: 1px solid #18a2b8;
  color: #18a2b8;
  border-radius: 10px;
  font-weight: bold;
  text-decoration: none;
  font-size: 16px;
}

.classic-login {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.classic-login span {
  flex: 1;
  border-top: 1px solid #18a2b8;
}

.classic-link {
  padding: 0 12px;
  font-size: 14px;
  font-weight: bold;
  color: #18a2b8;
  cursor: pointer;
}

.lang-switcher {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
}
</style>
